import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import AdminModal from '../AdminModal';
import BinderData from './BinderData';

const ModalWrapper = styled.div`
  padding: 1rem;
  height: 100%;
  overflow-x: auto;
`;

const BinderAdminViewModal = ({
  loading,
  onClose,
  selectedIds = [],
  binders = [],
  type,
  data,
  selectedInfo
}) => {
  const showDoneModalNode = React.useRef();

  const onCloseModal = () => {
    onClose();
  };

  const OBJECTS = data.filter(
    (i) =>
      !!selectedIds.find((si) => {
        return si === i.binder.id;
      })
  );
  return (
    <AdminModal
      ref={showDoneModalNode}
      onClose={onCloseModal}
      label={'Binder Viewer'}
      name={'Binder Viewer'}
      Component={() => (
        <ModalWrapper>
          {OBJECTS.map((OneBinder, key) => (
            <BinderData
              key={key}
              binder={OneBinder.binder}
              organizationId={OneBinder.organizationId}
              type={type}
            />
          ))}
        </ModalWrapper>
      )}
    />
  );
};

export default BinderAdminViewModal;
